import { apiSlice } from './apiSlice'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  access_token: string
  token_type: string
}

export interface User {
  id: string
  username: string
  email: string
  full_name?: string
  role: string
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login-json',
        method: 'POST',
        body: credentials,
      }),
    }),
    googleLogin: builder.mutation<{ access_token: string; token_type: string; user: User }, { id_token: string }>({
      query: (data) => ({
        url: '/auth/google',
        method: 'POST',
        body: data,
      }),
    }),
    getMe: builder.query<User, void>({
      query: () => '/auth/me',
      providesTags: ['User'],
    }),
    refreshToken: builder.mutation<LoginResponse, void>({
      query: () => ({
        url: '/auth/refresh',
        method: 'POST',
      }),
    }),
  }),
})

export const { useLoginMutation, useGoogleLoginMutation, useGetMeQuery } = authApi
